// src/api/adminApi.ts
import { SupportTicketSummaryApi } from "@/types/supportTicket";
import axiosInstance from "./axiosInstance"; // Reusing your axios instance

// POST function to send data to the backend for admin search
export const createSupportTicket = async (
  payload:null| Record<string, any>
): Promise<any> => {
  try {
    const response = await axiosInstance.post(
      `api/support/ticket/create-ticket`, // API endpoint with query params
      payload // Body of the POST request
    );
    return response.data; // Return the server response
  } catch (error) {
   
    throw error; // Rethrow the error to be handled by calling code
  }
};





// src/api/supportTicketSummary.ts
// If you already have a pre-configured axios instance (e.g., api.ts), import that instead of fetch.
// Here I'll use fetch for zero-dependency; swap to axios if your project standardizes on it.



export const fetchSupportTicketSummary = async (): Promise<SupportTicketSummaryApi> => {
  try {
    const response = await axiosInstance.get('/api/support/ticket/fetch-tickets');
    return response.data; // The response will be typed as `ApproverListResponse`
  } catch (error) {
    console.error('Error fetching support ticket summary:', error);
    throw error;
  }
};